import { z } from '@bonanza-social/toolkit/api';

export const RegisterSchema = z.object({
  credentialId: z.number(),
});

export const BiometricsStartSchema = z.object({
  challenge: z.string(),
});

export const BiometricsFinishSchema = z.object({
  authorizationCode: z.string(),
});
